import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { eChuanDauRaChungChiActionIds, IChuanDauRaChungChiActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuanDauRaChungChiActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { chuanDauRaChungChiApi } from "../../../api/chuong-trinh-dao-tao/chuanDauRaChungChiApi";
import { rootActions } from "../../actions/rootActions";
import { IChuanDauRaChungChiSysRequest } from "../../../model/request/chuong-trinh-dao-tao/IChuanDauRaChungChiSysRequest";

export function* chuanDauRaChungChiSaga() {
    yield takeLatest(eChuanDauRaChungChiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eChuanDauRaChungChiActionIds.SYS_START, sysWorker);
}

function* loadWorker() : any {
    const res: IBaseResponse = yield call(chuanDauRaChungChiApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuanDauRaChungChi.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuanDauRaChungChi.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* sysWorker(action: IChuanDauRaChungChiActionTypes) : any {
    const request = action.payload as IChuanDauRaChungChiSysRequest;
    const res: IBaseResponse = yield call(chuanDauRaChungChiApi.Sys, request);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuanDauRaChungChi.SYS_SUCCESS(undefined));
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_START(undefined));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuanDauRaChungChi.SYS_ERROR(res.message ?? "Có lỗi"));
    }
}